export default __webpack_public_path__ + "static/product-unit-14-profession-576f8ba6d04fa9d1727ea7eb6e3bf5ae.png";